import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/homePage.vue";
import SubContent from "../views/subContent.vue";
import ArcticleDetail from "../views/arcticleDetail.vue";
import ListContent from "../views/listContent.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
  },
  {
    path: "/detail",
    name: "detail",
    component: SubContent,
  },
  {
    path: "/article-detail/:id",
    name: "arcticle",
    component: ArcticleDetail,
  },
  {
    path: "/list",
    name: "list",
    component: ListContent,
  },
  {
    path: "/:path(.*)",
    component: HomePage,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
